export default __webpack_public_path__ + "static/media/down.58bbfa4c.svg";